import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import ScrollIndicator from "@/components/landing/ScrollIndicator";
import heroBgVideo from "@/assets/diagnostic-hero-bg.mp4";


const DiagnosticHero = () => {
  const scrollToTest = () => {
    const testSection = document.getElementById("test");
    if (testSection) {
      testSection.scrollIntoView({
        behavior: "smooth"
      });
    }
  };

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-black">
      {/* Background video */}
      <div className="absolute inset-0">
        <video 
          src={heroBgVideo} 
          autoPlay 
          loop 
          muted 
          playsInline
          className="w-full h-full object-cover"
        />
        {/* Color overlay */}
        <div 
          className="absolute inset-0" 
          style={{ 
            background: "rgba(29, 74, 140, 0.6)" 
          }} 
        />
        {/* Blue glow overlay */}
        <div 
          className="absolute inset-0" 
          style={{ 
            background: "radial-gradient(ellipse 80% 100% at 0% 50%, rgba(37, 99, 235, 0.3) 0%, rgba(37, 99, 235, 0.1) 30%, transparent 70%)" 
          }} 
        />
      </div>

      {/* Content */}
      <div className="container relative z-10 px-4 py-20">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="flex flex-col items-center text-center max-w-4xl mx-auto"
        >
          {/* Badge - BRANDWAY© */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mb-6"
          >
            <span className="text-2xl md:text-3xl tracking-[0.2em] uppercase text-white font-bold">
              BRANDWAY©
            </span>
          </motion.div>

          {/* Small title */}
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="text-base md:text-lg text-neutral-400 max-w-2xl mb-8 leading-relaxed font-light tracking-wide"
          >
            Para negocios con trayectoria que crecieron más rápido que su marca.
          </motion.p>

          {/* Main Headline */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="font-display text-4xl md:text-6xl lg:text-7xl font-medium leading-[1.1] mb-8 text-white tracking-tight"
          >
            Tu marca vale. Hacemos que ese valor{" "}
            <span 
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage: "linear-gradient(135deg, #60a5fa 0%, #93c5fd 100%)"
              }}
            >
              se vea, sienta y elija.
            </span>
          </motion.h1>

          {/* Elegant divider */}
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="w-16 h-px mb-8"
            style={{ background: "linear-gradient(to right, transparent, hsl(214, 95%, 77% / 0.5), transparent)" }}
          />

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.7 }}
            className="text-lg md:text-xl text-neutral-400 max-w-2xl mb-14 leading-relaxed font-light"
          >
            Renovamos tu identidad para transformar la percepción de tu marca. Un rebranding diseñado para{" "}
            <span className="text-white">blindar tu valor e incrementar tu autoridad</span> en solo 120 días.
          </motion.p>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.9 }}
          >
            <Button
              variant="gold"
              size="xl"
              className="tracking-wider font-semibold bg-[#7ab7fd] hover:bg-[#93c5fd] text-[#0a162a]"
              onClick={() => document.getElementById("inversion")?.scrollIntoView({ behavior: "smooth" })}
            >
              APLICAR
            </Button>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
        <ScrollIndicator onClick={scrollToTest} />
      </div>
    </section>
  );
};

export default DiagnosticHero;
